export const MotorTipoMoneda = [
    { TipoMonedaCoreUid: 1, TipoMonedaUid: 122 }, //SOLES
    { TipoMonedaCoreUid: 2, TipoMonedaUid: 121 }, //DOLARES
];

export const MotorTipoMonedaCodigos = {
    CodigoSoles: 1,
    CodigoDolares: 2,
};
